import React from "react";
import cx from "classnames";
import Timeout from "await-timeout";
import InterventionMultipleChoice from "../shared/InterventionMultipleChoice";
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions";

const expireTimer = new Timeout();

const EXPIRE_TIMEOUT = 30000;

export default class PredictionMultipleChoice extends InterventionMultipleChoice {
  constructor(props) {
    super(props);
    this.setExpireTimer = this.setExpireTimer.bind(this);
  }

  startTimer() {
    super.startTimer();
    const { enableButtons } = this.props;

    if (enableButtons) {
      enableButtons();
    }

    this.setExpireTimer();
  }

  setExpireTimer() {
    const { options, correctAnswer, disableButtons, expire } = this.props;

    expireTimer.set(EXPIRE_TIMEOUT).then(() => {
      if (this.state.selected.length == 0) {
        if (disableButtons) {
          disableButtons();
        }
        this.setState(
          { highlighted: options.indexOf(correctAnswer[0]) },
          () => {
            if (expire) {
              expire();
            }
          }
        );
      }
    });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    expireTimer.clear();
  }

  getOptions() {
    const { buttonsDisabled } = this.props;
    const disabledClass = buttonsDisabled === true ? " disabled " : "";

    let optionsClasses = cx({
      "multiple-options": true,
      flat: this.props.flat,
      keepTall: this.props.keepTall,
    });

    const accessibleOptionGroupAttributes = {
      role: "radiogroup",
      "aria-required": true,
      "aria-label": "options",
    }
    const getAccessibleOptionAttributes = (option, clickHandler) => {
      return {
        ...doNotUseAccessibleStaticElementInteractions({onClick: clickHandler.bind(this, option)}),
        role: "radio",
        "aria-label": option,
        "aria-checked": this.state.selected.includes(option),
      }
    }

    if (this.props.flat) {
      return (
        <div className={optionsClasses} {...accessibleOptionGroupAttributes}>
          {this.props.options.map((option, index) => {
            const liClass = this.state.selected.includes(option) ? " selected" : "";
            let highlightedClass = this.state.highlighted == index ? " highlightedOption" : "";
            const onOptionClickHandler = !buttonsDisabled ? this.selectOption.bind(this, option) : ()=>{};
            return (
              <span
                className={
                  "labelFontOverride option" +
                  liClass +
                  highlightedClass +
                  disabledClass
                }
                key={option}
                {...getAccessibleOptionAttributes(option, onOptionClickHandler)}
              >
                {option}
              </span>
            );
          })}
        </div>
      );
    } else {
      return (
        <div className={optionsClasses}>
          <ol className="list" {...accessibleOptionGroupAttributes}>
            {this.props.options.map((option, index) => {
              //TODO abstract this more with the above code
              const liClass = this.state.selected.includes(option) ? " selected" : "";
              let highlightedClass= this.state.highlighted == index ? " highlightedOption" : "";
              const onOptionClickHandler = !buttonsDisabled ? this.selectOption.bind(this, option) : ()=>{};
              return (
                <li key={option}>
                  <span
                    className={
                      "labelFontOverride option" +
                      liClass +
                      highlightedClass +
                      disabledClass
                    }
                    {...getAccessibleOptionAttributes(option, onOptionClickHandler)}
                  >
                    {option}
                  </span>
                </li>
              );
            })}
          </ol>
        </div>
      );
    }
  }
}
